import { field, date, children, writer, relation, json,text } from '@nozbe/watermelondb/decorators';
import { ATTENDANCE_SCHEMA, JOURNAL_SCHEMA, STAFF_SCHEMA } from '../schema';
import { uuid } from '../../oscar-pos-core/constants';
import { sanitizeWorkdays } from '../../constants';
import { Model } from '@nozbe/watermelondb';

export default class Staff extends Model {
    static table = STAFF_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
        attendance: { type: 'has_many', foreignKey: 'staff_id' },
        journal: { type: 'has_many', foreignKey: 'staff_id' },
    }

    @text('payment_method') payment_method;
    @text('account_number') account_number;
    @text('profile_image') profile_image;
    @field('working_hours') working_hours;
    @text('phone_number') phone_number;
    @field('open_balance') open_balance;
    @field('auto_present') auto_present;
    @text('salary_type') salary_type;
    @text('job_title') job_title;
    @field('is_synced') is_synced;
    @text('sms_alert') sms_alert;
    @text('workdays') workdays;
    @field('salary') salary;
    @text('name') name;
    @text('cnic') cnic;

    @date('last_updated_at') last_updated_at;
    @date('created_at') created_at;
    @date('joined_at') joined_at;

    @json('workdays', sanitizeWorkdays) workdays;

    @relation('business', 'business_id') business;

    @children('attendance') attendance;
    @children('journal') journal;

    @writer async updateStaff(details) {
        await this.update(staff => {
            staff.name = details.name
            staff.phone_number = details.phone_number
            staff.salary = details.salary
            staff.salary_type = details.salary_type
            staff.working_hours = details.working_hours
            staff.workdays = details.workdays
            staff.job_title = details.job_title
            staff.joined_at = details.joined_at
            staff.auto_present = details.auto_present
            staff.sms_alert = details.sms_alert
            staff.last_updated_at = details.last_updated_at
            staff.account_number = details.account_number
            staff.payment_method = details.payment_method
        })
    }

    @writer async createAttendance(details) {
        await this.collections.get(ATTENDANCE_SCHEMA).create(attendance => {
            attendance.staff.set(this)
            attendance.business.set(this.business);
            attendance._raw.id = details.id ? details.id : uuid()
            attendance.attendance_at = details.attendance_at
            attendance.check_in_at = details.check_in_at
            attendance.check_out_at = details.check_out_at
            attendance.status = details.status
            attendance.payment = details.payment
            attendance.last_updated_at = details.last_updated_at
            attendance.total_minutes = details.total_minutes;
            attendance.wage = details.wage;
            attendance.extra_payment = details.extra_payment
            attendance.extra_mode = details.extra_mode
            attendance.note = details.note
            attendance.work_rate = details.work_rate
            attendance.work_unit = details.work_unit
            attendance.work_name = details.work_name
        })
    }

    @writer async createJournalEntry(details) {
        await this.collections.get(JOURNAL_SCHEMA).create(journal => {
            journal.staff.set(this)
            journal.business.set(this.business);
            journal._raw.id = details.id
            journal.type = details.type
            journal.description = details.description
            journal.last_updated_at = details.last_updated_at
            journal.amount = details.amount
            journal.reference_id = details.reference_id;
            journal.created_at = details.created_at;
        })
    }

    @writer async updateStaffAccount(details) {
        await this.update(staff => {
            staff.account_number = details.account_number
            staff.payment_method = details.payment_method
            staff.cnic = details.cnic
        })
    }

    @writer async markAsDeleted() {
        await super.markAsDeleted();
    }
}